import { NAV_LINK_SELECTOR } from "./constants";
import { parseSectionHtml, replaceNode } from "./dom";

export const patchHeaderFromHtml = (headerSection: HTMLElement, headerHtml: string, preserveNav: boolean) => {
  const remote = parseSectionHtml(headerHtml, ".js-collection-header");
  if (!remote) return false;

  replaceNode(headerSection.querySelector("#subcollections-breadcrumbs"), remote.querySelector("#subcollections-breadcrumbs"));
  replaceNode(headerSection.querySelector("[data-ek-hero-wrapper]"), remote.querySelector("[data-ek-hero-wrapper]"));

  if (preserveNav) {
    for (const [key, value] of Object.entries(remote.dataset)) {
      headerSection.dataset[key] = value;
    }
    return true;
  }

  replaceNode(headerSection.querySelector("#subcollections-menu"), remote.querySelector("#subcollections-menu"));

  const remoteNavWrap = remote.querySelector("#subcollections-menu")?.parentElement;
  const currentNavWrap = headerSection.querySelector("#subcollections-menu")?.parentElement;
  if (remoteNavWrap && currentNavWrap) {
    currentNavWrap.className = remoteNavWrap.className;
  }

  for (const [key, value] of Object.entries(remote.dataset)) {
    headerSection.dataset[key] = value;
  }

  return true;
};

export const shouldPreserveSubcollectionNav = (headerSection: HTMLElement, navParent: string | null) => {
  if (!navParent || !headerSection.querySelector("#subcollections-menu")) return false;
  const menuNavParent = headerSection.querySelector<HTMLAnchorElement>(NAV_LINK_SELECTOR)?.dataset.navParent ?? null;
  return menuNavParent === navParent;
};
